'use strict';

function getImageUrl(image, size) {
  return (
    image &&
    image.mediaUrl.replace('{{options}}', `w_${size.width},h_${size.height},`)
  );
}

function getImageSource({ data, size, conquestOffer }) {
  if (conquestOffer) {
    return getImageUrl(conquestOffer.offerMedia, size);
  }

  const image =
    Array.isArray(data) && data.find(({ mediaType }) => mediaType === 'Logo');

  return getImageUrl(image, size);
}

module.exports.getImageSource = getImageSource;
